import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useConnectResultToast } from '@/pages/Integrations/use-connect-result-toast';
import { useIntegrationOAuthListener } from '@/pages/Integrations/oauth-bridge';

function IntegrationsLayout() {
  // Surface the OAuth callback outcome (?status=connected|error) on any
  // /integrations/* landing the BE redirects back to (same-tab fallback).
  useConnectResultToast();
  // New-tab flow: when consent completes in the popup, the bridge broadcasts
  // here and we route to the discovery review.
  useIntegrationOAuthListener();
  return <Outlet />;
}

export const Route = createFileRoute('/integrations')({
  component: IntegrationsLayout,
});
